<div class="banner-view container">
  {{banner?.name}}
</div>
